<template>
  <section
    class="Collaborate-with container box-shaddow20 border-r-20 bg-white mt-5 pt-4 pb-4"
  >
    <!-- <div class="titleCollaborate-with mb-4 gap-12">
      <figure class="bg-dark figure-titleCollaborate-with mb-0">
        <img src="@/assets/images/BRAND-02.jpg" class="w-100 h-100" alt="" />
      </figure>
      <figure class="bg-dark figure-titleCollaborate-with mb-0">
        <img src="@/assets/images/BRAND-03.jpg" class="w-100 h-100" alt="" />
      </figure>
      <figure class="bg-dark figure-titleCollaborate-with mb-0">
        <img src="@/assets/images/BRAND-04.jpg" class="w-100 h-100" alt="" />
      </figure>
      <div class="info-title">
        <p class="mb-0 fontsize14 text-color-666">Nike Brands</p>
        <h5 class="mb-0 font-bold fontsize-16 weight-bold">
          همکاری با برند نایک
        </h5>
      </div>
    </div> -->
    <div class="titleCollaborate-with mb-4">
      <div id="" class="swiper-container overflow-hidden position-relative">
        <div class="swiper-wrapper border-r-20">
          <div class="swiper-slide border-r-20">
            <figure class="bg-dark figure-titleCollaborate-with mb-0">
              <img
                src="@/assets/images/BRAND-01.jpg"
                class="w-100 h-100"
                alt=""
              />
            </figure>
          </div>
          <div class="swiper-slide border-r-20">
            <figure class="bg-dark figure-titleCollaborate-with mb-0">
              <img
                src="@/assets/images/BRAND-02.jpg"
                class="w-100 h-100"
                alt=""
              />
            </figure>
          </div>
          <div class="swiper-slide border-r-20">
            <figure class="bg-dark figure-titleCollaborate-with mb-0">
              <img
                src="@/assets/images/BRAND-03.jpg"
                class="w-100 h-100"
                alt=""
              />
            </figure>
          </div>
          <div class="swiper-slide border-r-20">
            <figure class="bg-dark figure-titleCollaborate-with mb-0">
              <img
                src="@/assets/images/BRAND-04.jpg"
                class="w-100 h-100"
                alt=""
              />
            </figure>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-baseline gap-lg-40"
      >
        <h5 class="text-color-444 my-lg-4 font-weight-bold">
          <span class="font-weight-bold">چالش‌ها</span>
        </h5>
        <span class="line-about d-none d-lg-block mx-3"></span>
        <p class="text-color-999">اعتمادسازی در دنیایی پر از تبلیغات</p>
      </div>
      <p class="line-height2 text-color-666 fontsize14 text-justify">
        هر کسب‌وکار موفقی در ابتدای مسیر با چالش‌هایی روبه‌رو می‌شود، و بندیتو
        هم از این قاعده مستثنا نبود. ما از روز اول تصمیم گرفتیم محصولاتی طبیعی و
        گیاهی تولید کنیم، اما این مسیر ساده نبود.
      </p>
      <p class="line-height2 text-color-666 fontsize14 text-justify">
        🔹 بسیاری از افراد هنوز فکر می‌کردند که روغن‌های گیاهی نمی‌توانند
        جایگزین محصولات شیمیایی شوند.
      </p>
      <p class="line-height2 text-color-666 fontsize14 text-justify">
        🔹 بازار پر از محصولاتی بود که ادعای "طبیعی و گیاهی" بودن داشتند، اما در
        واقع پر از مواد افزودنی مضر بودند.
      </p>
      <p class="line-height2 text-color-666 fontsize14 text-justify">
        🔹 تولید محصولات کاملاً طبیعی و خالص، فرآیندی پیچیده‌تر و پرهزینه‌تر
        بود. اما ما باور داشتیم که یک محصول باکیفیت، خودش حرفش را می‌زند. پس
        تصمیم گرفتیم به جای تبلیغات غیرواقعی، تمرکزمان را روی آگاهی‌بخشی، آموزش
        و ارائه محصولات باکیفیت واقعی بگذاریم.
      </p>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min";

export default {
  components: {},
  mounted() {
    this.initRelatedProducts();
  },
  //   computed: {
  //     amazingSuggest() {
  //       if (this.$store.getters["front/getHomeData"] == null) {
  //         return [];
  //       } else {
  //         return this.$store.getters["front/getHomeData"].mostSales;
  //       }
  //     },
  //   },
  //   watch: {
  //     amazingSuggest(newValue) {
  //       if (newValue) {
  //         this.initRelatedProducts(true);
  //       }
  //     },
  //   },
  methods: {
    initRelatedProducts(kill = false) {
      this.initSwiper("asliderAbout", kill, () => {
        let swiper = new Swiper(".titleCollaborate-with .swiper-container", {
          // loop: true,
          speed: 500,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          breakpoints: {
            300: {
              slidesPerView: 2.2,
              spaceBetween: 15,
            },
            400: {
              slidesPerView: 3.2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            992: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 7,
              spaceBetween: 30,
            },
          },
        });
      });
    },
  },
};
</script>
<style scoped>
.line-about {
  height: 1px;
  background-color: #e7e7e7;
  flex-grow: 1;
}
.titleCollaborate-with {
  width: 97%;
  margin: 0 auto;
  background-color: #f4f4f4;
  border-radius: 15px;
  padding: 15px;
}
.titleCollaborate-with .info-title {
  padding: 16px 0px;
}
.figure-titleCollaborate-with {
  border-radius: 15px;
  display: grid;
  place-items: center;
}
</style>
